import { lazy } from 'react'
import { createBrowserRouter } from 'react-router-dom'
import { authRoutes } from '@/features/auth/router'
import RequireAuth from '@/app/guards/RequireAuth'
import RouteErrorPage from './RouteErrorPage'

const ProtectedRouter = lazy(() => import('./protected-router'))

export const router = createBrowserRouter([
  ...authRoutes.map((route) => ({ ...route, errorElement: <RouteErrorPage /> })),
  {
    path: '*',
    element: <RequireAuth><ProtectedRouter /></RequireAuth>,
    errorElement: <RouteErrorPage />,
  },
])
